module.exports = __webpack_public_path__ + "media/images/1img-81a5c532c3fac2eaf6aa8012c51d6f5c.jpeg";